function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#282828;}.cls-2{fill:#fff;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1-2",
  "data-name": "Ebene 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2-2",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1-2-2",
  "data-name": "Ebene 1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,0H41A22,22,0,0,1,63,22v1.59a22,22,0,0,1-22,22H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M36.87,12.09h-5a3.55,3.55,0,0,0-6.71,0h-5a2.4,2.4,0,0,0-2.33,2.39v19a2.4,2.4,0,0,0,2.38,2.38h16.6a2.38,2.38,0,0,0,2.37-2.38v-19A2.39,2.39,0,0,0,36.87,12.09Zm-8.33,0a1.21,1.21,0,0,1,1.21,1.19,1.2,1.2,0,0,1-2.4,0v0A1.21,1.21,0,0,1,28.54,12.09ZM36.87,33.5H20.22v-19h2.37V18h11.9V14.48h2.38Z"
})))));

const SvgCopyLink = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 62.98 45.59",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopyLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copyLink.a9ed247d.svg";
export { ForwardRef as ReactComponent };